import MondayCrmIcon from "static/svg/header/mobile_crm_gray.svg";
import MondayServiceIcon from "static/svg/header/mobile_monday_service_gray.svg";
import MondayDevIcon from "static/svg/header/mobile_monday_dev_gray.svg";
import { ENTERPRISE_PAGE_LINK, SMB_PAGE_LINK, CRM_MINI_SITE_LINK, SERVICE_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, RETAIL_PAGE_LINK, MEDIA_PAGE_LINK, GOVERNMENT_PAGE_LINK } from "constants/links";
export const COMPANY_SIZE_ITEMS = [
    {
        labelKey: "header.tabs.solution.enterprise.title",
        link: ENTERPRISE_PAGE_LINK,
        variant: "text"
    },
    {
        labelKey: "header.tabs.solution.smb.title",
        link: SMB_PAGE_LINK,
        variant: "text"
    }
];
export const BUSINESS_APPLICATION_ITEMS = [
    {
        labelKey: "header.tabs.products.mondaySalesCRM.title",
        link: CRM_MINI_SITE_LINK,
        variant: "icon",
        Icon: MondayCrmIcon
    },
    {
        labelKey: "header.tabs.products.mondayService.title",
        link: SERVICE_MINI_SITE_LINK,
        variant: "icon",
        Icon: MondayServiceIcon
    },
    {
        labelKey: "header.tabs.products.mondayDev.title",
        link: SOFTWARE_MINI_SITE_LINK,
        variant: "icon",
        Icon: MondayDevIcon
    }
];
export const INDUSTRIES_ITEMS = [
    {
        labelKey: "header.tabs.solution.retail",
        link: RETAIL_PAGE_LINK,
        variant: "text"
    },
    {
        labelKey: "header.tabs.solution.media",
        link: MEDIA_PAGE_LINK,
        variant: "text"
    },
    {
        labelKey: "header.tabs.solution.government",
        link: GOVERNMENT_PAGE_LINK,
        variant: "text"
    }
];
export const SOLUTIONS_SECTIONS = [
    {
        groupKey: "header.tabs.solution.title.companySize",
        items: COMPANY_SIZE_ITEMS
    },
    {
        groupKey: "header.tabs.solution.title.businessApplications",
        items: BUSINESS_APPLICATION_ITEMS
    },
    {
        groupKey: "header.tabs.solution.title.industries",
        items: INDUSTRIES_ITEMS
    }
];
